import baseUrl from "./environment";

export default baseUrl;